import { useState } from "react";
import { BarChart3, BookOpen, CircleHelp, Landmark, Send, Sparkles } from "lucide-react";
import { ReportCard } from "@/components/ReportCard";

const starterPrompts = ["Give CRM report", "Show clients with pending payments", "Show registration backlog", "Show loan sanction and disbursement status"];

function EmptyState({ onAsk }) {
  return (
    <div className="empty-state">
      <div className="empty-icon"><Sparkles size={23} /></div>
      <h2>What would you like to know?</h2>
      <p>Ask about bookings, collections, registrations, or loans in plain language.</p>
      {/*<div className="prompt-grid">
        {starterPrompts.map((p, i) => <button key={p} className="prompt-card" data-testid={`starter-prompt-${i}`} onClick={() => onAsk(p)}><span>{p}</span><Send size={15} /></button>)}
      </div>*/}
    </div>
  );
}

function Conversation({ messages, busy }) {
  return (
    <div className="conversation" data-testid="conversation-window">
      {messages.map((m, i) => m.role === "user"
        ? <div className="user-message" data-testid={`user-message-${i}`} key={m.id}>{m.text}</div>
        : <ReportCard report={m.report} key={m.id} />)}
      {busy && <div className="typing" data-testid="report-loading"><span></span><span></span><span></span> Building your report</div>}
    </div>
  );
}

function Composer({ busy, onAsk, onReport }) {
  const [question, setQuestion] = useState("");
  const submit = () => { if (!question.trim() || busy) return; onAsk(question); setQuestion(""); };
  return (
    <div className="composer-wrap">
      <div className="quick-report-actions" aria-label="Quick reports">
        <button type="button" className="quick-report-btn" data-testid="give-crm-report-button" disabled={busy} onClick={() => onReport("crm")}><BarChart3 size={16} /> Give CRM Report</button>
        <button type="button" className="quick-report-btn" data-testid="give-loan-report-button" disabled={busy} onClick={() => onReport("loan")}><Landmark size={16} /> Loan Report</button>
      </div>
      <form className="composer" onSubmit={e => { e.preventDefault(); submit(); }}>
        <textarea value={question} data-testid="report-question-input" onChange={e => setQuestion(e.target.value)} placeholder="Ask a question about your projects…" rows="1" onKeyDown={e => { if (e.key === "Enter" && !e.shiftKey) { e.preventDefault(); submit(); } }} />
        <button className="send-btn" data-testid="send-report-button" disabled={!question.trim() || busy}><Send size={17} /></button>
      </form>
      <div className="composer-meta"><span><BookOpen size={13} /> Figures are computed from synced sheet data — AI only interprets and explains</span><span>Press <kbd>Enter</kbd> to send</span></div>
    </div>
  );
}

export function ChatView({ messages, busy, notice, onAsk, onReport }) {
  return (
    <>
      {notice && <div className="notice" data-testid="system-notice"><CircleHelp size={16} /> {notice}</div>}
      {messages.length ? <Conversation messages={messages} busy={busy} /> : <EmptyState onAsk={onAsk} />}
      <Composer busy={busy} onAsk={onAsk} onReport={onReport} />
    </>
  );
}
